import { I18n } from '@calendly/i18n';
import { AlertWarningCircleIcon, ArrowExpandIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { colorBgGrey1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { capitalize } from 'lodash-es';
import { useMemo, forwardRef } from 'react';
import { getPayPalIntegrationSlugForReconnect, isPayPalProvider } from './payment_provider_utils';
const errorMessageWrapperCss = "e1t43huk";
const ErrorMessageWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorMessageWrapperCss, props.className)} />;
});
const messageWithIconCss = "m5p14s3";
const MessageWithIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(messageWithIconCss, props.className)} />;
});
export const StatusBanner = ({
  provider,
  isStripeConnected,
  isPaypalConnected,
  isPaypalPpcpConnected = false,
  isPaypalPpcpFeatureEnabled = false
}) => {
  let isPaypalUiConnected = false;
  if (provider === 'paypal_ppcp') {
    isPaypalUiConnected = !!isPaypalPpcpFeatureEnabled && !!isPaypalPpcpConnected;
  } else if (provider === 'paypal') {
    isPaypalUiConnected = !!isPaypalConnected;
  }
  const statuses = useMemo(() => ({
    stripe: {
      isConnected: isStripeConnected
    },
    paypal: {
      isConnected: isPaypalUiConnected
    }
  }), [isStripeConnected, isPaypalUiConnected]);
  const statusKey = isPayPalProvider(provider) ? 'paypal' : provider;
  const status = statuses[statusKey];
  if (!provider || provider === 'none' || !status || status.isConnected) return null;
  let integrationSlug = 'paypal';
  if (provider === 'stripe') {
    integrationSlug = 'stripe';
  } else if (provider === 'paypal_ppcp') {
    integrationSlug = 'paypal_ppcp';
  } else {
    integrationSlug = getPayPalIntegrationSlugForReconnect({
      isPaypalConnected
    });
  }
  const providerLabel = isPayPalProvider(provider) ? 'paypal' : provider;
  return <ErrorMessageWrapper>
      <MessageWithIcon>
        <AlertWarningCircleIcon spacingRight={8} color={colorBgGrey1} />
        {I18n.t('publisher.event_types.payment_method.integration_disconnected_short', {
        provider: capitalize(providerLabel)
      })}
      </MessageWithIcon>
      <MinimalButton as="a" fontSize="medium" href={`/integrations/${integrationSlug}`} target="_blank" rel="noopener noreferrer">
        <ArrowExpandIcon />
        {I18n.t('publisher.action.reconnect')}
      </MinimalButton>
    </ErrorMessageWrapper>;
};

require("./status_banner.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./status_banner.js");